import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Hidden from '@material-ui/core/Hidden';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, {useContext, useEffect, useState} from 'react';
import CDNlogo from '../../../../images/CDN-logo.svg';
import logoSebrae from '../../../../images/slogo-cinza.png';
import {getBySub} from '../../../../services/usuario/UsuarioService';
import {AppContext} from '../../context';
import useStyles from './styles';
import Roles from "../../../../layouts/role";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [usuarioLogado, setUsuarioLogado] = useState({});
  const isMenuOpen = Boolean(anchorEl);

  const { keycloak } = useContext(AppContext);
  let tokenParsed = '';

  if (keycloak) {
    tokenParsed = keycloak.tokenParsed;
  }
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (tokenParsed) {
      const { sub } = tokenParsed;

      if (sub) {
        getBySub(sub).then((response) => {
          console.log(response)
          if (response && response.status === 200) {
            const { data } = response;
            setUsuarioLogado(data);
          }
        })
      }
    }
  }, [])

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >

    
      <Roles header="true"></Roles>

      <MenuItem style={{justifyContent:'flex-end'}} onClick={() => window.location = `/usuario/${usuarioLogado.id}`}>Meu Perfil</MenuItem>

      <MenuItem style={{ flexDirection: 'column', alignItems: 'flex-end' }} onClick={() => keycloak.logout()}>
        Sair
        <span
          style={{ color: '#a6a6ba', fontSize: '0.75rem' }}
        >
          {usuarioLogado.emailInstitucional}
        </span>
      </MenuItem>
    </Menu>
  );

  const classes = useStyles();
  return (
    <>
      <AppBar position="static" className={classes.navbar}>
        <Toolbar className={classes.espacamento} variant="dense">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div>
              <img alt="CDNlogo" src={CDNlogo} className={classes.img} />
            </div>
            <Hidden xsDown>
              <Typography className={classes.titulo}>
                Conselho Deliberativo Nacional do Sebrae
              </Typography>
            </Hidden>
          </div>
          <div style={{ display: 'flex' }}>
            {tokenParsed
            && (
              <>
                <MenuItem onClick={handleProfileMenuOpen} style={{ paddingRight: 0 }}>
                  <span
                    style={{ color: '#044ada', fontWeight: '500' }}
                  >
                    {usuarioLogado.nome}
                    {' '}
                    {usuarioLogado.sobrenome}
                  </span>
                  <ExpandMoreIcon className={classes.icon} />
                </MenuItem>

                <Avatar className={classes.backgroundAzul}>{usuarioLogado?.nome?.substring(0, 2).toUpperCase()}</Avatar>

                {renderMenu}
              </>
            )}
            <Hidden xsDown>
              <img alt="logoSebrae" src={logoSebrae} className={classes.logoSebrae} />
            </Hidden>
            {keycloak && (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }} />
              </>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
}

export default Header;
